import { EmptyState } from '../components/ui';

export default function MarketingSection() {
  return (
    <div className="space-y-4">
      <EmptyState
        title="Marketing — production tracker"
        message="Manual entry section. Each row is a client job with platform, stage, publish date, and RAG status. Will sync from ActiveCampaign Deals once that's wired. Add the form component in src/sections/MarketingSection.tsx."
      />
      <EmptyState
        title="Meta ad spend"
        message="Will populate once Meta Ads Account ID is set in the Worker. Currently the Meta source pulls Instagram organic insights only — extend src/sources/meta.ts to also call /act_<account_id>/insights."
      />
    </div>
  );
}
